import template from './hueb-seo-rich.html.twig';

const { Component, Mixin, Store } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('hueb-seo-rich', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('placeholder')
    ],

    computed: {
        isLoading: () => Store.get('swOrderDetail').isLoading,
        richSnippets: () => Store.get('huebSeoProductDetail').richSnippets,
        parentRichSnippets: () => Store.get('huebSeoProductDetail').parentRichSnippets,
    },

    data() {
        return {
            configRepository: null,
            active: true,
            optionsItemCondition: null,
            optionsAvailability: null,
        }
    },

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            this.configRepository = this.repositoryFactory.create('system_config');
            this.optionsItemCondition = [
                {value: null, label: this.$tc('hueb-seo.card.rich.optionDefault')},
                {value: 'https://schema.org/NewCondition', label: this.$tc('hueb-seo.card.rich.optionNew')},
                {value: 'https://schema.org/RefurbishedCondition', label: this.$tc('hueb-seo.card.rich.optionRefurbished')},
                {value: 'https://schema.org/UsedCondition', label: this.$tc('hueb-seo.card.rich.optionUsed')},
                {value: 'https://schema.org/DamagedCondition', label: this.$tc('hueb-seo.card.rich.optionDamaged')}];
            this.optionsAvailability = [
                {value: null, label: this.$tc('hueb-seo.card.rich.optionDefault')},
                {value: 'https://schema.org/Discontinued', label: this.$tc('hueb-seo.card.rich.optionDiscontinued')},
                {value: 'https://schema.org/InStock', label: this.$tc('hueb-seo.card.rich.optionInStock')},
                {value: 'https://schema.org/InStoreOnly', label: this.$tc('hueb-seo.card.rich.optionInStoreOnly')},
                {value: 'https://schema.org/LimitedAvailability', label: this.$tc('hueb-seo.card.rich.optionLimitedAvailability')},
                {value: 'https://schema.org/OnlineOnly', label: this.$tc('hueb-seo.card.rich.optionOnlineOnly')},
                {value: 'https://schema.org/OutOfStock', label: this.$tc('hueb-seo.card.rich.optionOutOfStock')},
                {value: 'https://schema.org/PreOrder', label: this.$tc('hueb-seo.card.rich.optionPreOrder')},
                {value: 'https://schema.org/PreSale', label: this.$tc('hueb-seo.card.rich.optionPreSale')},
                {value: 'https://schema.org/SoldOut', label: this.$tc('hueb-seo.card.rich.optionSoldOut')}];
            this.setActive();
        },

        setActive() {
            const configCriteria = new Criteria();
            configCriteria.addFilter(Criteria.contains('configurationKey', 'HuebertSeoUltimate.config.conversion.rich'));
            this.configRepository.search(configCriteria, Shopware.Context.api)
                .then((entity) => {
                    if(entity.length)
                        this.active = entity[0].configurationValue.active;
                    else
                        this.active = false;
                });
        }
    }
});
